module.exports = __webpack_public_path__ + "img/phone.4b1bcc67.png";